import * as React from 'react';
import { DefaultLayout } from '../../../../components/DefaultLayout';
import { Seo } from '../../../../components/Seo';

import { YandexMetrika } from '../../../../components/YandexMetrika';
import { MailRu } from '../../../../components/MailRu';
import { TikTok } from '../../../../components/TikTok';
import { VKPixel } from '../../../../components/VKPixel';
import { AdvCake } from '../../../../components/AdvCake';

import { TaxDeduction } from '../../../../components/TaxDeduction';
import { Modal } from '../../../../components/Modal';
import { FooterMedium } from '../../../../components/FooterMedium';
import { GetCourseWidget } from '../../../../components/GetCourseWidget';
import { VideoReviewsSimple } from '../../../../components/VideoReviewsSimple';

import {
  HeaderWithNav,
  Results,
  ResultsAndReviewsTop,
  Tasks,
  HowWorks,
  BlocksCourseStructure,
  AboutPeople,
  AboutAdvance,
  Founder,
  main,
} from '../../../../components/LandingTemplates/uchis_uchitsya';

import { blocksDataTeachers } from '../../../../components/LandingTemplates/uchis_uchitsya/data/blocksDataTeachers';
import navData from './data/navData.json';
import reviewsTop from './data/reviewsTop.json';
import methodistsData from './data/methodistsDataNew.json';
import videoReviews from './data/videoReviewsSimple.json';

import * as screen1 from './styles/screen1.module.scss';
import * as cost from './styles/cost.module.scss';
import * as problems from './styles/problems.module.scss';
const Screen1 = () => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderWithNav data={navData} buttonText={'Купить курс'} modal={false} noContainer={true} />

        <div className={screen1.screen1__container}>
          <div>
            <div className={screen1.screen1__titleWrapper}>
              <h1 className={screen1.screen1__title}>
                Курс «Учись Учиться 8–11 класс» <br />
                для преподавателей
              </h1>
              <h2 className={screen1.screen1__subtitle}>
                Технологии, которые помогут вам стать востребованным преподавателем и улучшат результаты ваших учеников
              </h2>
            </div>
            <div className={screen1.screen1__infoWrapper}>
              <div className={screen1.screen1__infoCol}>
                <p className={screen1.screen1__text}>
                  Рекомендован Навигатором образования Минпросвещения РФ и Смартекой
                </p>
                <div className={screen1.screen1__imageWrapper}>
                  <img
                    src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_vzroslyh/uchis_uchitsya-teachers/logo-minprosvet.svg"
                    alt="Минпросвещения России"
                    width="120%"
                    height="auto"
                  />
                  <img
                    src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_vzroslyh/uchis_uchitsya-teachers/logo-smarteka.png"
                    alt="Смартека"
                    width="85%"
                    height="auto"
                  />
                </div>
              </div>
            </div>
            <div className={screen1.screen1__linkWrapper}>
              <a className={main.mainBtn} href="#user-action">
                Купить курс
              </a>
            </div>
          </div>
          <img
            src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_vzroslyh/uchis_uchitsya-teachers/screen-1-img.png"
            className={screen1.screen1__imgTeacher}
            alt=""
          />
        </div>
      </div>
    </header>
  );
};

const ProblemsWithVideo = () => {
  return (
    <section className={problems.problems}>
      <div className="container">
        <h2 className={main.title2}>Хотите...</h2>
        <ul className={problems.problems__list}>
          <li className={problems.problems__listItem}>
            <p className={problems.problems__listText}>
              познакомиться с методиками обучения, которые помогут вашим ученикам запоминать информацию в 2 раза
              быстрее?
            </p>
          </li>
          <li className={problems.problems__listItem}>
            <p className={problems.problems__listText}>
              вести занятия так, чтобы ученики с нетерпением ждали следующего урока?
            </p>
          </li>
          <li className={problems.problems__listItem}>
            <p className={problems.problems__listText}>чтобы ваши ученики сдавали экзамены на отлично?</p>
          </li>
          <li className={problems.problems__listItem}>
            <p className={problems.problems__listText}>улучшить свою репутацию и стать Учителем года?</p>
          </li>
          <li className={problems.problems__listItem}>
            <p className={problems.problems__listText}>чтобы ученики стали призёрами олимпиад?</p>
          </li>
          <li className={problems.problems__listItem}>
            <p className={problems.problems__listText}>
              cтать востребованным репетитором, к которому стоит очередь на год вперёд?
            </p>
          </li>
        </ul>
        <p className={problems.problems__text}>… в этом вам помогут технологии Advance!</p>
        <div className={problems.video__content}>
          <div className={problems.video__screencastWrapper}>
            <iframe
              className={problems.video__content_iframe}
              src="https://www.youtube.com/embed/EGrw3oQ2vXg"
              title={'Видео Учись учиться 8-11'}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <p className={problems.video__text}>2-минутное видеознакомство с&nbsp;курсом «Учись Учиться» </p>
        </div>
        <p className={problems.problems__undertext}>
          Пройдя курс «Учись Учиться 8 – 11 класс» вы овладеете технологиями, которые полностью изменят вашу
          преподавательскую карьеру
        </p>
      </div>
    </section>
  );
};
const Cost = ({ widgetOtlichnik, widgetTeacher }) => {
  const [showModalOtlichnik, setShowModalOtlichnik] = React.useState(false);
  const [showModalTeacher, setShowModalTeacher] = React.useState(false);
  return (
    <section className={cost.cost} id="user-action">
      <div className="container">
        <h2 className={cost.cost__title}>Сколько стоит курс «Учись учиться 8–11 класс»</h2>
        <div className={cost.cost__row}>
          <div className={cost.cost__wrapper}>
            <div className={cost.cost__info}>
              <h3 className={`${cost.cost__heading} ${cost.cost__headingOtl}`}>Пакет для учеников «Отличник»</h3>
              <ul className={cost.cost__list}>
                <li className={cost.cost__item}>Доступ к курсу на&nbsp;2&nbsp;года</li>
                <li className={cost.cost__item}>2 академических часа индивидуальных занятий</li>
                <li className={cost.cost__item}>
                  1 развернутая консультация
                  <br />
                  для родителей
                </li>
                <li className={cost.cost__item}>Поддержка кураторов</li>
              </ul>
              <div className={cost.cost__priceWrapper}>
                <p className={cost.cost__priceText}>При единовременной оплате</p>
                <p>
                  <span className={`${cost.cost__price} ${cost.cost__priceOtl}`}>99&nbsp;900&nbsp;₽</span>
                </p>
                <p className={cost.cost__priceText}>В рассрочку на&nbsp;10&nbsp;месяцев:</p>
                <p>
                  <span className={`${cost.cost__price} ${cost.cost__priceOtl}`}>9&nbsp;990&nbsp;₽</span>
                </p>
              </div>
            </div>

            <div className={`${cost.cost__blockBtn} block-btn`}>
              <button
                className={`${cost.cost__btn} ${main.mainBtn}`}
                onClick={() => {
                  setShowModalOtlichnik(true);
                }}
              >
                Изменить будущее ребенка
              </button>
            </div>
          </div>

          <div className={cost.cost__wrapper}>
            <div className={cost.cost__info}>
              <h3 className={`${cost.cost__heading} ${cost.cost__headingTeach}`}>Пакет для педагогов</h3>
              <ul className={cost.cost__list}>
                <li className={cost.cost__item}>Доступ к курсу на&nbsp;2&nbsp;года</li>
                <li className={cost.cost__item}>Удостоверение о повышении квалификации гос.образца</li>
                <li className={cost.cost__item}>1 консультация для преподавателей</li>
                <li className={cost.cost__item}>Поддержка кураторов</li>
              </ul>
              <div className={cost.specialPrice}>
                <p>
                  Специальная цена действует при подтверждении педагогом своей квалификации и анонсом о прохождении
                  курса в своих соц.сетях
                </p>
              </div>
              <div className={cost.cost__priceWrapper}>
                <p className={cost.cost__priceText}>При единовременной оплате</p>
                <p>
                  <span className={`${cost.cost__price} ${cost.cost__priceTeach}`}>49&nbsp;900&nbsp;₽</span>
                </p>
                <p className={cost.cost__priceText}>В рассрочку на&nbsp;10&nbsp;месяцев:</p>
                <p>
                  <span className={`${cost.cost__price} ${cost.cost__priceTeach}`}>4&nbsp;990&nbsp;₽</span>
                </p>
              </div>
            </div>

            <div className={`${cost.cost__blockBtn} block-btn`}>
              <button
                className={`${cost.cost__btn} ${main.mainBtn}`}
                onClick={() => {
                  setShowModalTeacher(true);
                }}
              >
                Купить курс
              </button>
            </div>
          </div>
        </div>
        <TaxDeduction className={cost.cost__undertext} />
      </div>
      <Modal
        open={showModalOtlichnik}
        onClose={() => {
          setShowModalOtlichnik(false);
        }}
      >
        {widgetOtlichnik}
      </Modal>

      <Modal
        open={showModalTeacher}
        onClose={() => {
          setShowModalTeacher(false);
        }}
      >
        {widgetTeacher}
      </Modal>
    </section>
  );
};

const TITLE = 'Курс «Учись Учиться 8–11 класс» для преподавателей';
const DESCRIPTION =
  'Технологии, которые помогут вам стать востребованным преподавателем и улучшат результаты ваших учеников';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontSize: '20px' }}>
      <Screen1 />
      <ProblemsWithVideo />
      <Results title={'Вы сможете помочь своим ученикам:'} />
      <ResultsAndReviewsTop data={reviewsTop} />
      <Tasks />
      <HowWorks accessTimeText={'Доступ к нашей обучающей платформе на 2 года:'} />
      <BlocksCourseStructure
        data={blocksDataTeachers}
        buttonText={'Оставить заявку'}
        buttonClassName={main.mainBtn}
        buttonAction={'anchor'}
      />
      <AboutPeople
        data={methodistsData}
        sectionClassName={main.methodists}
        title={'Над курсом работали:'}
        titleClassName={main.title2}
        bottomText={[
          <b>И ещё более 90 специалистов разного профиля:</b>,
          ' методистов, педагогов, разработчиков,' +
            ' специалистов по мультимедиа продакшену, дизайнеров, сценаристов.',
        ]}
        bottomTextClassName={main.methodists__bottomText}
      />
      <AboutAdvance />
      <Founder />
      <Cost
        widgetOtlichnik={<GetCourseWidget hash={'582d946fe352779bc3ba5413a494e675fc5ae609'} id={'722307'} />}
        widgetTeacher={<GetCourseWidget hash={'6efc2fdd431ab9731c75a5ff4b2173eb6b94459c'} id={'722324'} />}
      />
      <VideoReviewsSimple data={videoReviews} sectionClassName={main.sec} titleClassName={main.title2} />
    </main>

    <FooterMedium />
  </DefaultLayout>
);

export default Page;
